import { Sprite, Texture } from 'pixi.js';
import { SineInOut } from '../../../../helpers/Easing';

export default class StepFrame extends Sprite {
  show: number;
  hideStart = 0;
  hideEnd = 0;
  hideLength = 0;

  constructor(frameId: number, showValue: number, hideValue: number) {
    super(Texture.from(`s-${frameId}`));

    // vars
    this.show = showValue;
    this.hideStart = hideValue;
    this.hideLength = (this.hideStart - this.show) * 0.3;
    this.hideEnd = this.hideStart + this.hideLength;

    // props
    this.anchor.set(0.5);
  }

  // --------------------------------------------------------------
  // Update
  // --------------------------------------------------------------

  update(scroll: number): void {
    if (scroll >= this.show && scroll <= this.hideEnd) {
      this.visible = true;
      const progress = Math.min(1, Math.max(0, (scroll - this.hideStart) / this.hideLength));
      const easedProgress = SineInOut(progress);
      this.alpha = 1 - easedProgress;
      this.scale.set(1.33334 + easedProgress * 0.05);
    } else {
      this.visible = false;
    }
  }
}
